// import Vue from 'vue'
import findTopicValue from './find-topic-value'
import getSearchConfig from '../functions/get-search-config'

export default (route, topics) => {
  // const route = Vue.prototype.$route
  const filterTypes = getSearchConfig().filterTypes
  const slugToFilter = getSearchConfig().slugToFilter

  const settings = []

  filterTypes.forEach(filterType => {
    let parameter
    // hardcoded topic id
    if (filterType.id === slugToFilter.id) {
      parameter = findTopicValue(topics, route.params.topic)
    } else {
      parameter = route.query[filterType.id]
    }
    settings[filterType.id] = parameter || ''
  })

  settings.search = route.query.search || ''

  return settings
}
